// extracted by mini-css-extract-plugin
export default {"section":"MySection_section__XzdoG","downarrow":"MySection_downarrow__rNny5","bounce":"MySection_bounce__bu46p"};